import { ChangeDetectorRef, Inject, Injectable, computed, effect, inject } from '@angular/core';
import {BehaviorSubject, firstValueFrom, Observable, of, throwError} from 'rxjs';
import { catchError, retry, switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Ability, AbilityBuilder } from '@casl/ability';
import { KeycloakService } from 'keycloak-angular';
import { JwtService } from './jwt.service';
import { SignalStore } from 'src/app/shared/functions/store.functions';
import { createEffect } from 'src/app/shared/functions/create-effect.functions';
import { AuthState } from '../models/auth.model';
import { AUTH_CONFIG } from 'src/app/config/auth.config';
import { environment } from 'src/environments/environment';
import { Rules } from '../models/authorization-rules.model';
import { ApiService } from './api.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { RoleState } from '../models/role.model';
import { LocalStorageService } from './local-storage.service';
import { UtentiService } from './utenti.service';
import { ApiSentrynelService } from './api-sentrynel.service';
import { jwtKeycloakModel } from '../models/jwt-keyclaok.model';
import { Router } from '@angular/router';

const AUTH_ENDPOINT = environment.apiSentrynelUrl;
const LOGIN_PAGE_URL = `${AUTH_ENDPOINT}/login`;
const PROFILE_URL = `${AUTH_ENDPOINT}/auth/user`;
const TOKEN_URL = `${AUTH_ENDPOINT}/auth/token`;
const LOGOUT_URL = `${AUTH_ENDPOINT}/logout`;
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private defineAbilitySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // Aggiungi un flag observable che indica se l'abilità è stata definita
  public abilityDefined$: Observable<boolean> = this.defineAbilitySubject.asObservable();

  readonly user = this.authStore.select(store => store.user);
  public isAuthenticated = computed(() => this.jwtService.isValidToken());
  public isSetUser = toSignal(this.abilityDefined$, { initialValue: false });
  private userLoadedSubject = new BehaviorSubject<boolean>(false);
  public userLoaded$ = this.userLoadedSubject.asObservable();

  constructor(
    public readonly utentiService: UtentiService,
    private jwtService: JwtService,
    private keycloakService:KeycloakService,
    private apiService: ApiService,
    private apiSentrynelService: ApiSentrynelService,
    private ability: Ability,
    private https:HttpClient,
    private localStorageService:LocalStorageService,
    private readonly router: Router,
    @Inject('auth-store') private readonly authStore = inject(SignalStore<AuthState>),
    @Inject('role-store') private readonly roleStore = inject(SignalStore<RoleState>)
  ) {
    effect(() => {
      if (AUTH_CONFIG.fetchUserAfterLogin && this.isAuthenticated()) {
        this.fetchUser();
      }
    },
    {
      allowSignalWrites: true, // Enable writing to signals inside effects
    });
  }

  private defineAbility(rolePerm: any): void {

    const { can, rules } = new AbilityBuilder(Ability);

    const regole: Rules[] = Array.isArray(rolePerm) ? rolePerm.shift().permissions : rolePerm.permissions;
    regole.forEach(regola => {
      can(regola?.action, regola.subject!);
    });
    this.ability.update(rules);

    this.defineAbilitySubject.next(true);
  }

  public async fetchUser(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.https.get<any>(PROFILE_URL).pipe(

        catchError(error => {
          this.handleError(error);
          reject(error);
          return throwError(error);
        }),
        tap((user) => {
          this.authStore.setKey('user', user);
          this.userLoadedSubject.next(true);
        //  var roll=user.authorization.roles.join(",")
  /*         this.utentiService.getRoles(roll).subscribe((val:any)=>
            {

              if(val.data.length>0){
                this.roleStore.setKey('role', val.data)

                if(this.localStorageService.getItem('role')!=null && this.isStringNumber(this.localStorageService.getItem('role'))){
                //da scommentare nel caso servisse ruoloAntea
                 // this.apiService.setHeader('RuoloAntea', this.localStorageService.getItem('role')!)

                    this.defineAbility(this.roleStore.selectKey('role')().filter((el:any)=>{

                    return el.id==parseInt(this.localStorageService.getItem('role')!)

                  }));
                }else{
                  //da scommentare nel caso servisse ruoloAntea
                 // this.apiService.setHeader('RuoloAntea', this.roleStore.selectKey('role')()[0].id)
                  this.localStorageService.setItem('role', this.roleStore.selectKey('role')()[0].id)
                  this.defineAbility(this.roleStore.selectKey('role')()[0]);
                }

              }

            }) */


          resolve(); // Risolvi la promessa dopo aver definito l'abilità
        })
      ).subscribe();
    });
  }
  async login() {
    this.apiService.get('auth/loginPage').subscribe((el:any)=>{
      let urlKeycloak = el?.loginPage.replace("client_id=antea_test", "client_id=psa").replace("client_id=antea", "client_id=psa")
      window.location.href=urlKeycloak+"&scope=openid&redirect_uri="+encodeURIComponent(environment.keycloak.redirectUrl)
    })
  }
  exchangeCodeForToken(code: string) {

      const body = {
          grant_type:'authorization_code',
          client_id : environment.keycloak.clientId,
          code: code,
          redirect_uri: environment.keycloak.redirectUrl
        }
        return this.apiService.post('auth/token', body);
  }

  async getToken(codeUrl: string): Promise<void> {

    try {
    const el: any = await firstValueFrom(
        this.exchangeCodeForToken(codeUrl)
      );

      if (el?.access_token) {

       await this.jwtService.set(el.access_token);
       await this.jwtService.setIdTokenHint(el.id_token)
       await this.jwtService.setRefreshToken(el.refresh_token)

      }

    } catch (error) {
      console.error('Errore durante il recupero del token:', error);
    }

}

  logout() {
  let idTokenHint = this.jwtService.getIdTokenHint()

    this.apiService.get(`auth/logout?id_token_hint=${encodeURIComponent(idTokenHint)}`).subscribe((el:any)=>{

       this.jwtService.unset()
        localStorage.clear()
        this.login()

  })
}
  handleError(error: any): any {
    throw new Error('Method not implemented.');
  }


}
